/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ReturnsRouteImport } from './routes/returns'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as ResendConfirmationRouteImport } from './routes/resend-confirmation'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as ConfirmEmailRouteImport } from './routes/confirm-email'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as AccountRouteImport } from './routes/account'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ReturnsIndexRouteImport } from './routes/returns.index'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as AccountIndexRouteImport } from './routes/account.index'
import { Route as ReturnsReturnIdRouteImport } from './routes/returns.$returnId'
import { Route as LoginRecoveryCodeRouteImport } from './routes/login.recovery-code'
import { Route as Login2faRouteImport } from './routes/login.2fa'
import { Route as AdminUsersRouteImport } from './routes/admin.users'
import { Route as AdminStripeRouteImport } from './routes/admin.stripe'
import { Route as AdminSettingsRouteImport } from './routes/admin.settings'
import { Route as AdminReturnsRouteImport } from './routes/admin.returns'
import { Route as AdminReferenceRouteImport } from './routes/admin.reference'
import { Route as AdminPaymentsRouteImport } from './routes/admin.payments'
import { Route as AdminAuditRouteImport } from './routes/admin.audit'
import { Route as AdminAgentRouteImport } from './routes/admin.agent'
import { Route as AccountEmailRouteImport } from './routes/account.email'
import { Route as AccountChangePasswordRouteImport } from './routes/account.change-password'
import { Route as Account2faRouteImport } from './routes/account.2fa'
import { Route as AdminReturnsIndexRouteImport } from './routes/admin.returns.index'
import { Route as ReturnsReturnIdReviewRouteImport } from './routes/returns.$returnId.review'
import { Route as ReturnsReturnIdPersonalRouteImport } from './routes/returns.$returnId.personal'
import { Route as ReturnsReturnIdOtherRouteImport } from './routes/returns.$returnId.other'
import { Route as ReturnsReturnIdIncomeRouteImport } from './routes/returns.$returnId.income'
import { Route as ReturnsReturnIdIdentityRouteImport } from './routes/returns.$returnId.identity'
import { Route as ReturnsReturnIdDeductionsRouteImport } from './routes/returns.$returnId.deductions'
import { Route as AdminReturnsIdRouteImport } from './routes/admin.returns.$id'
import { Route as AdminReferenceTitlesRouteImport } from './routes/admin.reference.titles'
import { Route as AdminReferenceOccupationsRouteImport } from './routes/admin.reference.occupations'
import { Route as AdminAgentPrefillRouteImport } from './routes/admin.agent.prefill'
import { Route as AdminAgentConversationsRouteImport } from './routes/admin.agent.conversations'
import { Route as AdminAgentConcernsRouteImport } from './routes/admin.agent.concerns'
import { Route as AccountEmailConfirmRouteImport } from './routes/account.email.confirm'

const ReturnsRoute = ReturnsRouteImport.update({
  id: '/returns',
  path: '/returns',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const ResendConfirmationRoute = ResendConfirmationRouteImport.update({
  id: '/resend-confirmation',
  path: '/resend-confirmation',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const ConfirmEmailRoute = ConfirmEmailRouteImport.update({
  id: '/confirm-email',
  path: '/confirm-email',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountRoute = AccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ReturnsIndexRoute = ReturnsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ReturnsRoute,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any)
const AccountIndexRoute = AccountIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AccountRoute,
} as any)
const ReturnsReturnIdRoute = ReturnsReturnIdRouteImport.update({
  id: '/$returnId',
  path: '/$returnId',
  getParentRoute: () => ReturnsRoute,
} as any)
const LoginRecoveryCodeRoute = LoginRecoveryCodeRouteImport.update({
  id: '/recovery-code',
  path: '/recovery-code',
  getParentRoute: () => LoginRoute,
} as any)
const Login2faRoute = Login2faRouteImport.update({
  id: '/2fa',
  path: '/2fa',
  getParentRoute: () => LoginRoute,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AdminRoute,
} as any)
const AdminStripeRoute = AdminStripeRouteImport.update({
  id: '/stripe',
  path: '/stripe',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSettingsRoute = AdminSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AdminRoute,
} as any)
const AdminReturnsRoute = AdminReturnsRouteImport.update({
  id: '/returns',
  path: '/returns',
  getParentRoute: () => AdminRoute,
} as any)
const AdminReferenceRoute = AdminReferenceRouteImport.update({
  id: '/reference',
  path: '/reference',
  getParentRoute: () => AdminRoute,
} as any)
const AdminPaymentsRoute = AdminPaymentsRouteImport.update({
  id: '/payments',
  path: '/payments',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAuditRoute = AdminAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAgentRoute = AdminAgentRouteImport.update({
  id: '/agent',
  path: '/agent',
  getParentRoute: () => AdminRoute,
} as any)
const AccountEmailRoute = AccountEmailRouteImport.update({
  id: '/email',
  path: '/email',
  getParentRoute: () => AccountRoute,
} as any)
const AccountChangePasswordRoute = AccountChangePasswordRouteImport.update({
  id: '/change-password',
  path: '/change-password',
  getParentRoute: () => AccountRoute,
} as any)
const Account2faRoute = Account2faRouteImport.update({
  id: '/2fa',
  path: '/2fa',
  getParentRoute: () => AccountRoute,
} as any)
const AdminReturnsIndexRoute = AdminReturnsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminReturnsRoute,
} as any)
const ReturnsReturnIdReviewRoute = ReturnsReturnIdReviewRouteImport.update({
  id: '/review',
  path: '/review',
  getParentRoute: () => ReturnsReturnIdRoute,
} as any)
const ReturnsReturnIdPersonalRoute = ReturnsReturnIdPersonalRouteImport.update({
  id: '/personal',
  path: '/personal',
  getParentRoute: () => ReturnsReturnIdRoute,
} as any)
const ReturnsReturnIdOtherRoute = ReturnsReturnIdOtherRouteImport.update({
  id: '/other',
  path: '/other',
  getParentRoute: () => ReturnsReturnIdRoute,
} as any)
const ReturnsReturnIdIncomeRoute = ReturnsReturnIdIncomeRouteImport.update({
  id: '/income',
  path: '/income',
  getParentRoute: () => ReturnsReturnIdRoute,
} as any)
const ReturnsReturnIdIdentityRoute = ReturnsReturnIdIdentityRouteImport.update({
  id: '/identity',
  path: '/identity',
  getParentRoute: () => ReturnsReturnIdRoute,
} as any)
const ReturnsReturnIdDeductionsRoute =
  ReturnsReturnIdDeductionsRouteImport.update({
    id: '/deductions',
    path: '/deductions',
    getParentRoute: () => ReturnsReturnIdRoute,
  } as any)
const AdminReturnsIdRoute = AdminReturnsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AdminReturnsRoute,
} as any)
const AdminReferenceTitlesRoute = AdminReferenceTitlesRouteImport.update({
  id: '/titles',
  path: '/titles',
  getParentRoute: () => AdminReferenceRoute,
} as any)
const AdminReferenceOccupationsRoute =
  AdminReferenceOccupationsRouteImport.update({
    id: '/occupations',
    path: '/occupations',
    getParentRoute: () => AdminReferenceRoute,
  } as any)
const AdminAgentPrefillRoute = AdminAgentPrefillRouteImport.update({
  id: '/prefill',
  path: '/prefill',
  getParentRoute: () => AdminAgentRoute,
} as any)
const AdminAgentConversationsRoute = AdminAgentConversationsRouteImport.update({
  id: '/conversations',
  path: '/conversations',
  getParentRoute: () => AdminAgentRoute,
} as any)
const AdminAgentConcernsRoute = AdminAgentConcernsRouteImport.update({
  id: '/concerns',
  path: '/concerns',
  getParentRoute: () => AdminAgentRoute,
} as any)
const AccountEmailConfirmRoute = AccountEmailConfirmRouteImport.update({
  id: '/confirm',
  path: '/confirm',
  getParentRoute: () => AccountEmailRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/account': typeof AccountRouteWithChildren
  '/admin': typeof AdminRouteWithChildren
  '/confirm-email': typeof ConfirmEmailRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRouteWithChildren
  '/register': typeof RegisterRoute
  '/resend-confirmation': typeof ResendConfirmationRoute
  '/reset-password': typeof ResetPasswordRoute
  '/returns': typeof ReturnsRouteWithChildren
  '/account/2fa': typeof Account2faRoute
  '/account/change-password': typeof AccountChangePasswordRoute
  '/account/email': typeof AccountEmailRouteWithChildren
  '/admin/agent': typeof AdminAgentRouteWithChildren
  '/admin/audit': typeof AdminAuditRoute
  '/admin/payments': typeof AdminPaymentsRoute
  '/admin/reference': typeof AdminReferenceRouteWithChildren
  '/admin/returns': typeof AdminReturnsRouteWithChildren
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/stripe': typeof AdminStripeRoute
  '/admin/users': typeof AdminUsersRoute
  '/login/2fa': typeof Login2faRoute
  '/login/recovery-code': typeof LoginRecoveryCodeRoute
  '/returns/$returnId': typeof ReturnsReturnIdRouteWithChildren
  '/account/': typeof AccountIndexRoute
  '/admin/': typeof AdminIndexRoute
  '/returns/': typeof ReturnsIndexRoute
  '/account/email/confirm': typeof AccountEmailConfirmRoute
  '/admin/agent/concerns': typeof AdminAgentConcernsRoute
  '/admin/agent/conversations': typeof AdminAgentConversationsRoute
  '/admin/agent/prefill': typeof AdminAgentPrefillRoute
  '/admin/reference/occupations': typeof AdminReferenceOccupationsRoute
  '/admin/reference/titles': typeof AdminReferenceTitlesRoute
  '/admin/returns/$id': typeof AdminReturnsIdRoute
  '/returns/$returnId/deductions': typeof ReturnsReturnIdDeductionsRoute
  '/returns/$returnId/identity': typeof ReturnsReturnIdIdentityRoute
  '/returns/$returnId/income': typeof ReturnsReturnIdIncomeRoute
  '/returns/$returnId/other': typeof ReturnsReturnIdOtherRoute
  '/returns/$returnId/personal': typeof ReturnsReturnIdPersonalRoute
  '/returns/$returnId/review': typeof ReturnsReturnIdReviewRoute
  '/admin/returns/': typeof AdminReturnsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/confirm-email': typeof ConfirmEmailRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRouteWithChildren
  '/register': typeof RegisterRoute
  '/resend-confirmation': typeof ResendConfirmationRoute
  '/reset-password': typeof ResetPasswordRoute
  '/account/2fa': typeof Account2faRoute
  '/account/change-password': typeof AccountChangePasswordRoute
  '/account/email': typeof AccountEmailRouteWithChildren
  '/admin/agent': typeof AdminAgentRouteWithChildren
  '/admin/audit': typeof AdminAuditRoute
  '/admin/payments': typeof AdminPaymentsRoute
  '/admin/reference': typeof AdminReferenceRouteWithChildren
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/stripe': typeof AdminStripeRoute
  '/admin/users': typeof AdminUsersRoute
  '/login/2fa': typeof Login2faRoute
  '/login/recovery-code': typeof LoginRecoveryCodeRoute
  '/returns/$returnId': typeof ReturnsReturnIdRouteWithChildren
  '/account': typeof AccountIndexRoute
  '/admin': typeof AdminIndexRoute
  '/returns': typeof ReturnsIndexRoute
  '/account/email/confirm': typeof AccountEmailConfirmRoute
  '/admin/agent/concerns': typeof AdminAgentConcernsRoute
  '/admin/agent/conversations': typeof AdminAgentConversationsRoute
  '/admin/agent/prefill': typeof AdminAgentPrefillRoute
  '/admin/reference/occupations': typeof AdminReferenceOccupationsRoute
  '/admin/reference/titles': typeof AdminReferenceTitlesRoute
  '/admin/returns/$id': typeof AdminReturnsIdRoute
  '/returns/$returnId/deductions': typeof ReturnsReturnIdDeductionsRoute
  '/returns/$returnId/identity': typeof ReturnsReturnIdIdentityRoute
  '/returns/$returnId/income': typeof ReturnsReturnIdIncomeRoute
  '/returns/$returnId/other': typeof ReturnsReturnIdOtherRoute
  '/returns/$returnId/personal': typeof ReturnsReturnIdPersonalRoute
  '/returns/$returnId/review': typeof ReturnsReturnIdReviewRoute
  '/admin/returns': typeof AdminReturnsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/account': typeof AccountRouteWithChildren
  '/admin': typeof AdminRouteWithChildren
  '/confirm-email': typeof ConfirmEmailRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRouteWithChildren
  '/register': typeof RegisterRoute
  '/resend-confirmation': typeof ResendConfirmationRoute
  '/reset-password': typeof ResetPasswordRoute
  '/returns': typeof ReturnsRouteWithChildren
  '/account/2fa': typeof Account2faRoute
  '/account/change-password': typeof AccountChangePasswordRoute
  '/account/email': typeof AccountEmailRouteWithChildren
  '/admin/agent': typeof AdminAgentRouteWithChildren
  '/admin/audit': typeof AdminAuditRoute
  '/admin/payments': typeof AdminPaymentsRoute
  '/admin/reference': typeof AdminReferenceRouteWithChildren
  '/admin/returns': typeof AdminReturnsRouteWithChildren
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/stripe': typeof AdminStripeRoute
  '/admin/users': typeof AdminUsersRoute
  '/login/2fa': typeof Login2faRoute
  '/login/recovery-code': typeof LoginRecoveryCodeRoute
  '/returns/$returnId': typeof ReturnsReturnIdRouteWithChildren
  '/account/': typeof AccountIndexRoute
  '/admin/': typeof AdminIndexRoute
  '/returns/': typeof ReturnsIndexRoute
  '/account/email/confirm': typeof AccountEmailConfirmRoute
  '/admin/agent/concerns': typeof AdminAgentConcernsRoute
  '/admin/agent/conversations': typeof AdminAgentConversationsRoute
  '/admin/agent/prefill': typeof AdminAgentPrefillRoute
  '/admin/reference/occupations': typeof AdminReferenceOccupationsRoute
  '/admin/reference/titles': typeof AdminReferenceTitlesRoute
  '/admin/returns/$id': typeof AdminReturnsIdRoute
  '/returns/$returnId/deductions': typeof ReturnsReturnIdDeductionsRoute
  '/returns/$returnId/identity': typeof ReturnsReturnIdIdentityRoute
  '/returns/$returnId/income': typeof ReturnsReturnIdIncomeRoute
  '/returns/$returnId/other': typeof ReturnsReturnIdOtherRoute
  '/returns/$returnId/personal': typeof ReturnsReturnIdPersonalRoute
  '/returns/$returnId/review': typeof ReturnsReturnIdReviewRoute
  '/admin/returns/': typeof AdminReturnsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/account'
    | '/admin'
    | '/confirm-email'
    | '/forgot-password'
    | '/login'
    | '/register'
    | '/resend-confirmation'
    | '/reset-password'
    | '/returns'
    | '/account/2fa'
    | '/account/change-password'
    | '/account/email'
    | '/admin/agent'
    | '/admin/audit'
    | '/admin/payments'
    | '/admin/reference'
    | '/admin/returns'
    | '/admin/settings'
    | '/admin/stripe'
    | '/admin/users'
    | '/login/2fa'
    | '/login/recovery-code'
    | '/returns/$returnId'
    | '/account/'
    | '/admin/'
    | '/returns/'
    | '/account/email/confirm'
    | '/admin/agent/concerns'
    | '/admin/agent/conversations'
    | '/admin/agent/prefill'
    | '/admin/reference/occupations'
    | '/admin/reference/titles'
    | '/admin/returns/$id'
    | '/returns/$returnId/deductions'
    | '/returns/$returnId/identity'
    | '/returns/$returnId/income'
    | '/returns/$returnId/other'
    | '/returns/$returnId/personal'
    | '/returns/$returnId/review'
    | '/admin/returns/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/confirm-email'
    | '/forgot-password'
    | '/login'
    | '/register'
    | '/resend-confirmation'
    | '/reset-password'
    | '/account/2fa'
    | '/account/change-password'
    | '/account/email'
    | '/admin/agent'
    | '/admin/audit'
    | '/admin/payments'
    | '/admin/reference'
    | '/admin/settings'
    | '/admin/stripe'
    | '/admin/users'
    | '/login/2fa'
    | '/login/recovery-code'
    | '/returns/$returnId'
    | '/account'
    | '/admin'
    | '/returns'
    | '/account/email/confirm'
    | '/admin/agent/concerns'
    | '/admin/agent/conversations'
    | '/admin/agent/prefill'
    | '/admin/reference/occupations'
    | '/admin/reference/titles'
    | '/admin/returns/$id'
    | '/returns/$returnId/deductions'
    | '/returns/$returnId/identity'
    | '/returns/$returnId/income'
    | '/returns/$returnId/other'
    | '/returns/$returnId/personal'
    | '/returns/$returnId/review'
    | '/admin/returns'
  id:
    | '__root__'
    | '/'
    | '/account'
    | '/admin'
    | '/confirm-email'
    | '/forgot-password'
    | '/login'
    | '/register'
    | '/resend-confirmation'
    | '/reset-password'
    | '/returns'
    | '/account/2fa'
    | '/account/change-password'
    | '/account/email'
    | '/admin/agent'
    | '/admin/audit'
    | '/admin/payments'
    | '/admin/reference'
    | '/admin/returns'
    | '/admin/settings'
    | '/admin/stripe'
    | '/admin/users'
    | '/login/2fa'
    | '/login/recovery-code'
    | '/returns/$returnId'
    | '/account/'
    | '/admin/'
    | '/returns/'
    | '/account/email/confirm'
    | '/admin/agent/concerns'
    | '/admin/agent/conversations'
    | '/admin/agent/prefill'
    | '/admin/reference/occupations'
    | '/admin/reference/titles'
    | '/admin/returns/$id'
    | '/returns/$returnId/deductions'
    | '/returns/$returnId/identity'
    | '/returns/$returnId/income'
    | '/returns/$returnId/other'
    | '/returns/$returnId/personal'
    | '/returns/$returnId/review'
    | '/admin/returns/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AccountRoute: typeof AccountRouteWithChildren
  AdminRoute: typeof AdminRouteWithChildren
  ConfirmEmailRoute: typeof ConfirmEmailRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRouteWithChildren
  RegisterRoute: typeof RegisterRoute
  ResendConfirmationRoute: typeof ResendConfirmationRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  ReturnsRoute: typeof ReturnsRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/returns': {
      id: '/returns'
      path: '/returns'
      fullPath: '/returns'
      preLoaderRoute: typeof ReturnsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/resend-confirmation': {
      id: '/resend-confirmation'
      path: '/resend-confirmation'
      fullPath: '/resend-confirmation'
      preLoaderRoute: typeof ResendConfirmationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/confirm-email': {
      id: '/confirm-email'
      path: '/confirm-email'
      fullPath: '/confirm-email'
      preLoaderRoute: typeof ConfirmEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account': {
      id: '/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/returns/': {
      id: '/returns/'
      path: '/'
      fullPath: '/returns/'
      preLoaderRoute: typeof ReturnsIndexRouteImport
      parentRoute: typeof ReturnsRoute
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/account/': {
      id: '/account/'
      path: '/'
      fullPath: '/account/'
      preLoaderRoute: typeof AccountIndexRouteImport
      parentRoute: typeof AccountRoute
    }
    '/returns/$returnId': {
      id: '/returns/$returnId'
      path: '/$returnId'
      fullPath: '/returns/$returnId'
      preLoaderRoute: typeof ReturnsReturnIdRouteImport
      parentRoute: typeof ReturnsRoute
    }
    '/login/recovery-code': {
      id: '/login/recovery-code'
      path: '/recovery-code'
      fullPath: '/login/recovery-code'
      preLoaderRoute: typeof LoginRecoveryCodeRouteImport
      parentRoute: typeof LoginRoute
    }
    '/login/2fa': {
      id: '/login/2fa'
      path: '/2fa'
      fullPath: '/login/2fa'
      preLoaderRoute: typeof Login2faRouteImport
      parentRoute: typeof LoginRoute
    }
    '/admin/users': {
      id: '/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/stripe': {
      id: '/admin/stripe'
      path: '/stripe'
      fullPath: '/admin/stripe'
      preLoaderRoute: typeof AdminStripeRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/settings': {
      id: '/admin/settings'
      path: '/settings'
      fullPath: '/admin/settings'
      preLoaderRoute: typeof AdminSettingsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/returns': {
      id: '/admin/returns'
      path: '/returns'
      fullPath: '/admin/returns'
      preLoaderRoute: typeof AdminReturnsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/reference': {
      id: '/admin/reference'
      path: '/reference'
      fullPath: '/admin/reference'
      preLoaderRoute: typeof AdminReferenceRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/payments': {
      id: '/admin/payments'
      path: '/payments'
      fullPath: '/admin/payments'
      preLoaderRoute: typeof AdminPaymentsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/audit': {
      id: '/admin/audit'
      path: '/audit'
      fullPath: '/admin/audit'
      preLoaderRoute: typeof AdminAuditRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/agent': {
      id: '/admin/agent'
      path: '/agent'
      fullPath: '/admin/agent'
      preLoaderRoute: typeof AdminAgentRouteImport
      parentRoute: typeof AdminRoute
    }
    '/account/email': {
      id: '/account/email'
      path: '/email'
      fullPath: '/account/email'
      preLoaderRoute: typeof AccountEmailRouteImport
      parentRoute: typeof AccountRoute
    }
    '/account/change-password': {
      id: '/account/change-password'
      path: '/change-password'
      fullPath: '/account/change-password'
      preLoaderRoute: typeof AccountChangePasswordRouteImport
      parentRoute: typeof AccountRoute
    }
    '/account/2fa': {
      id: '/account/2fa'
      path: '/2fa'
      fullPath: '/account/2fa'
      preLoaderRoute: typeof Account2faRouteImport
      parentRoute: typeof AccountRoute
    }
    '/admin/returns/': {
      id: '/admin/returns/'
      path: '/'
      fullPath: '/admin/returns/'
      preLoaderRoute: typeof AdminReturnsIndexRouteImport
      parentRoute: typeof AdminReturnsRoute
    }
    '/returns/$returnId/review': {
      id: '/returns/$returnId/review'
      path: '/review'
      fullPath: '/returns/$returnId/review'
      preLoaderRoute: typeof ReturnsReturnIdReviewRouteImport
      parentRoute: typeof ReturnsReturnIdRoute
    }
    '/returns/$returnId/personal': {
      id: '/returns/$returnId/personal'
      path: '/personal'
      fullPath: '/returns/$returnId/personal'
      preLoaderRoute: typeof ReturnsReturnIdPersonalRouteImport
      parentRoute: typeof ReturnsReturnIdRoute
    }
    '/returns/$returnId/other': {
      id: '/returns/$returnId/other'
      path: '/other'
      fullPath: '/returns/$returnId/other'
      preLoaderRoute: typeof ReturnsReturnIdOtherRouteImport
      parentRoute: typeof ReturnsReturnIdRoute
    }
    '/returns/$returnId/income': {
      id: '/returns/$returnId/income'
      path: '/income'
      fullPath: '/returns/$returnId/income'
      preLoaderRoute: typeof ReturnsReturnIdIncomeRouteImport
      parentRoute: typeof ReturnsReturnIdRoute
    }
    '/returns/$returnId/identity': {
      id: '/returns/$returnId/identity'
      path: '/identity'
      fullPath: '/returns/$returnId/identity'
      preLoaderRoute: typeof ReturnsReturnIdIdentityRouteImport
      parentRoute: typeof ReturnsReturnIdRoute
    }
    '/returns/$returnId/deductions': {
      id: '/returns/$returnId/deductions'
      path: '/deductions'
      fullPath: '/returns/$returnId/deductions'
      preLoaderRoute: typeof ReturnsReturnIdDeductionsRouteImport
      parentRoute: typeof ReturnsReturnIdRoute
    }
    '/admin/returns/$id': {
      id: '/admin/returns/$id'
      path: '/$id'
      fullPath: '/admin/returns/$id'
      preLoaderRoute: typeof AdminReturnsIdRouteImport
      parentRoute: typeof AdminReturnsRoute
    }
    '/admin/reference/titles': {
      id: '/admin/reference/titles'
      path: '/titles'
      fullPath: '/admin/reference/titles'
      preLoaderRoute: typeof AdminReferenceTitlesRouteImport
      parentRoute: typeof AdminReferenceRoute
    }
    '/admin/reference/occupations': {
      id: '/admin/reference/occupations'
      path: '/occupations'
      fullPath: '/admin/reference/occupations'
      preLoaderRoute: typeof AdminReferenceOccupationsRouteImport
      parentRoute: typeof AdminReferenceRoute
    }
    '/admin/agent/prefill': {
      id: '/admin/agent/prefill'
      path: '/prefill'
      fullPath: '/admin/agent/prefill'
      preLoaderRoute: typeof AdminAgentPrefillRouteImport
      parentRoute: typeof AdminAgentRoute
    }
    '/admin/agent/conversations': {
      id: '/admin/agent/conversations'
      path: '/conversations'
      fullPath: '/admin/agent/conversations'
      preLoaderRoute: typeof AdminAgentConversationsRouteImport
      parentRoute: typeof AdminAgentRoute
    }
    '/admin/agent/concerns': {
      id: '/admin/agent/concerns'
      path: '/concerns'
      fullPath: '/admin/agent/concerns'
      preLoaderRoute: typeof AdminAgentConcernsRouteImport
      parentRoute: typeof AdminAgentRoute
    }
    '/account/email/confirm': {
      id: '/account/email/confirm'
      path: '/confirm'
      fullPath: '/account/email/confirm'
      preLoaderRoute: typeof AccountEmailConfirmRouteImport
      parentRoute: typeof AccountEmailRoute
    }
  }
}

interface AccountEmailRouteChildren {
  AccountEmailConfirmRoute: typeof AccountEmailConfirmRoute
}

const AccountEmailRouteChildren: AccountEmailRouteChildren = {
  AccountEmailConfirmRoute: AccountEmailConfirmRoute,
}

const AccountEmailRouteWithChildren = AccountEmailRoute._addFileChildren(
  AccountEmailRouteChildren,
)

interface AccountRouteChildren {
  Account2faRoute: typeof Account2faRoute
  AccountChangePasswordRoute: typeof AccountChangePasswordRoute
  AccountEmailRoute: typeof AccountEmailRouteWithChildren
  AccountIndexRoute: typeof AccountIndexRoute
}

const AccountRouteChildren: AccountRouteChildren = {
  Account2faRoute: Account2faRoute,
  AccountChangePasswordRoute: AccountChangePasswordRoute,
  AccountEmailRoute: AccountEmailRouteWithChildren,
  AccountIndexRoute: AccountIndexRoute,
}

const AccountRouteWithChildren =
  AccountRoute._addFileChildren(AccountRouteChildren)

interface AdminAgentRouteChildren {
  AdminAgentConcernsRoute: typeof AdminAgentConcernsRoute
  AdminAgentConversationsRoute: typeof AdminAgentConversationsRoute
  AdminAgentPrefillRoute: typeof AdminAgentPrefillRoute
}

const AdminAgentRouteChildren: AdminAgentRouteChildren = {
  AdminAgentConcernsRoute: AdminAgentConcernsRoute,
  AdminAgentConversationsRoute: AdminAgentConversationsRoute,
  AdminAgentPrefillRoute: AdminAgentPrefillRoute,
}

const AdminAgentRouteWithChildren = AdminAgentRoute._addFileChildren(
  AdminAgentRouteChildren,
)

interface AdminReferenceRouteChildren {
  AdminReferenceOccupationsRoute: typeof AdminReferenceOccupationsRoute
  AdminReferenceTitlesRoute: typeof AdminReferenceTitlesRoute
}

const AdminReferenceRouteChildren: AdminReferenceRouteChildren = {
  AdminReferenceOccupationsRoute: AdminReferenceOccupationsRoute,
  AdminReferenceTitlesRoute: AdminReferenceTitlesRoute,
}

const AdminReferenceRouteWithChildren = AdminReferenceRoute._addFileChildren(
  AdminReferenceRouteChildren,
)

interface AdminReturnsRouteChildren {
  AdminReturnsIdRoute: typeof AdminReturnsIdRoute
  AdminReturnsIndexRoute: typeof AdminReturnsIndexRoute
}

const AdminReturnsRouteChildren: AdminReturnsRouteChildren = {
  AdminReturnsIdRoute: AdminReturnsIdRoute,
  AdminReturnsIndexRoute: AdminReturnsIndexRoute,
}

const AdminReturnsRouteWithChildren = AdminReturnsRoute._addFileChildren(
  AdminReturnsRouteChildren,
)

interface AdminRouteChildren {
  AdminAgentRoute: typeof AdminAgentRouteWithChildren
  AdminAuditRoute: typeof AdminAuditRoute
  AdminPaymentsRoute: typeof AdminPaymentsRoute
  AdminReferenceRoute: typeof AdminReferenceRouteWithChildren
  AdminReturnsRoute: typeof AdminReturnsRouteWithChildren
  AdminSettingsRoute: typeof AdminSettingsRoute
  AdminStripeRoute: typeof AdminStripeRoute
  AdminUsersRoute: typeof AdminUsersRoute
  AdminIndexRoute: typeof AdminIndexRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminAgentRoute: AdminAgentRouteWithChildren,
  AdminAuditRoute: AdminAuditRoute,
  AdminPaymentsRoute: AdminPaymentsRoute,
  AdminReferenceRoute: AdminReferenceRouteWithChildren,
  AdminReturnsRoute: AdminReturnsRouteWithChildren,
  AdminSettingsRoute: AdminSettingsRoute,
  AdminStripeRoute: AdminStripeRoute,
  AdminUsersRoute: AdminUsersRoute,
  AdminIndexRoute: AdminIndexRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

interface LoginRouteChildren {
  Login2faRoute: typeof Login2faRoute
  LoginRecoveryCodeRoute: typeof LoginRecoveryCodeRoute
}

const LoginRouteChildren: LoginRouteChildren = {
  Login2faRoute: Login2faRoute,
  LoginRecoveryCodeRoute: LoginRecoveryCodeRoute,
}

const LoginRouteWithChildren = LoginRoute._addFileChildren(LoginRouteChildren)

interface ReturnsReturnIdRouteChildren {
  ReturnsReturnIdDeductionsRoute: typeof ReturnsReturnIdDeductionsRoute
  ReturnsReturnIdIdentityRoute: typeof ReturnsReturnIdIdentityRoute
  ReturnsReturnIdIncomeRoute: typeof ReturnsReturnIdIncomeRoute
  ReturnsReturnIdOtherRoute: typeof ReturnsReturnIdOtherRoute
  ReturnsReturnIdPersonalRoute: typeof ReturnsReturnIdPersonalRoute
  ReturnsReturnIdReviewRoute: typeof ReturnsReturnIdReviewRoute
}

const ReturnsReturnIdRouteChildren: ReturnsReturnIdRouteChildren = {
  ReturnsReturnIdDeductionsRoute: ReturnsReturnIdDeductionsRoute,
  ReturnsReturnIdIdentityRoute: ReturnsReturnIdIdentityRoute,
  ReturnsReturnIdIncomeRoute: ReturnsReturnIdIncomeRoute,
  ReturnsReturnIdOtherRoute: ReturnsReturnIdOtherRoute,
  ReturnsReturnIdPersonalRoute: ReturnsReturnIdPersonalRoute,
  ReturnsReturnIdReviewRoute: ReturnsReturnIdReviewRoute,
}

const ReturnsReturnIdRouteWithChildren = ReturnsReturnIdRoute._addFileChildren(
  ReturnsReturnIdRouteChildren,
)

interface ReturnsRouteChildren {
  ReturnsReturnIdRoute: typeof ReturnsReturnIdRouteWithChildren
  ReturnsIndexRoute: typeof ReturnsIndexRoute
}

const ReturnsRouteChildren: ReturnsRouteChildren = {
  ReturnsReturnIdRoute: ReturnsReturnIdRouteWithChildren,
  ReturnsIndexRoute: ReturnsIndexRoute,
}

const ReturnsRouteWithChildren =
  ReturnsRoute._addFileChildren(ReturnsRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AccountRoute: AccountRouteWithChildren,
  AdminRoute: AdminRouteWithChildren,
  ConfirmEmailRoute: ConfirmEmailRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRouteWithChildren,
  RegisterRoute: RegisterRoute,
  ResendConfirmationRoute: ResendConfirmationRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  ReturnsRoute: ReturnsRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
